import {
  CidadaoTerritorioBasico,
  CondicoesMoradia,
  Dsei,
  ImovelUltimasVisitasQuery,
  ImovelVisitaQuery,
  Maybe,
  Prontuario,
  TipoEnderecoEnum,
  TipoImovelEnum,
  VisualizarImovelHeaderQuery,
} from 'graphql/types.generated'

export type UltimasVisitasQueryResult = ImovelUltimasVisitasQuery['visitas']['content']
export type UltimasVisitasQueryResultRow = UltimasVisitasQueryResult[0]
export type ImovelVisitaResult = ImovelVisitaQuery['visita']

export const TipoOrigemRecord: Record<string, string> = {
  'Não informado': 'Não informado',
  OFFLINE: 'CDS Offline',
  ONLINE: 'CDS',
  PEC: 'PEC',
  EXTERNO: 'RAS PEC',
  ANDROID_ACS: 'e-SUS Território',
}

export interface ImovelUrlParams {
  imovelId: string
  cidadaoId: string
  redirect: string
  endereco: string
}

type ImovelHeaderAldeiaModel = NonNullable<VisualizarImovelHeaderQuery['imovel']>['aldeia']
type ImovelHeaderPoloBaseModel = NonNullable<VisualizarImovelHeaderQuery['imovel']>['poloBase']

export interface ImovelHeaderDto {
  tipoImovel: TipoImovelEnum | undefined
  bairro: string | undefined
  cep: string | undefined
  logradouro: string | undefined
  nomeTipoLogradouro: string | undefined
  nomeMunicipio: string | undefined
  siglaUfMunicipio: string | undefined
  complemento: string | undefined
  numero: string | undefined
  telefoneContato: string | undefined
  telefoneResidencial: string | undefined
  condicoesMoradia: CondicoesMoradia
  microarea: string | undefined
  latitude: number | undefined
  longitude: number | undefined
  tipoEndereco: TipoEnderecoEnum | undefined
  numeroResidenciaIndigena: string | undefined
  aldeia: ImovelHeaderAldeiaModel | undefined
  poloBase: ImovelHeaderPoloBaseModel | undefined
  dsei: Dsei | undefined
}

export type CidadaoTerritorioBasicoWithProntuarioId = Omit<CidadaoTerritorioBasico, 'prontuario'> & {
  prontuario?: Maybe<Pick<Prontuario, 'id'>>
}
